import React, {useMemo} from "react";
import './styles/InteractionsList.scss';
import PropTypes from "prop-types";
import classNames from "classnames";
import useDeviceSizeDetect from "../../hooks/useDeviceSizeDetect";
import Interactions, {
  INTERACTION_ID_FINGER_ACTION2,
  INTERACTION_ID_FINGER_CAMERA_ROTATE, INTERACTION_ID_FINGER_CHANGE_VIEW, INTERACTION_ID_FINGER_ZOOM,
  INTERACTION_ID_MOUSE_ACTION,
  INTERACTION_ID_MOUSE_ZOOM
} from "./constants";
import useWindowSize from "../../hooks/useWindowSize";

const interactionIdsDesktop = [
  INTERACTION_ID_MOUSE_ACTION,
  INTERACTION_ID_MOUSE_ZOOM,
];

const interactionIdsMobile = [
  INTERACTION_ID_FINGER_CAMERA_ROTATE,
  INTERACTION_ID_FINGER_ACTION2,
  INTERACTION_ID_FINGER_ZOOM,
  INTERACTION_ID_FINGER_CHANGE_VIEW,
];

export default function InteractionsList(props) {
  const detectMobile = useDeviceSizeDetect();
  const size = useWindowSize(200);
  
  const itemIdsMobile = props.mobileIds || interactionIdsMobile;
  const itemIdsDesktop = props.desktopIds || interactionIdsDesktop;
  
  const items = useMemo(() => {
    const itemsIds = detectMobile.isMobile ? itemIdsMobile : itemIdsDesktop;
    return itemsIds.map(id => Interactions.find((el => el.id === id)));
  }, [size.width])
  
  return (
    <>
      {
        items.length
          && <div className={classNames(["interactions-list", props.className])}>
          {
            items.map(({img, name, id}) => (
              <div key={id} className={classNames("interactions-list-item", id)}>
                <div className="interactions-list-img">
                  <img src={img} alt={name} className="interactions-list-img"/>
                </div>
                <p className="interactions-list-name">{name}</p>
              </div>
            ))
          }
        </div>
      }
    </>
  )
}

InteractionsList.propTypes = {
  mobileIds: PropTypes.arrayOf(PropTypes.string),
  desktopIds: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
};